import React from 'react'

function Comingsoon() {
  return (
    <div className="RightSideDiv">
         <div class="row">
            <div class="col-sm-12"> 
                <div className='comming-soon'>
                    <p>Coming Soon</p>
                </div>
                </div>
                </div>
                </div>
  )
}

export default Comingsoon